import { WRITING_ASSET as _writingAsset } from "../media/learnAssets";
export { WRITING_ASSET, WRITING_SHARED_ASSET, WRITING_WORD_ASSET } from "../media/learnAssets";

export function writingAccentWash(hex, alpha = 0.07) {
  const raw = String(hex || "#0065F8").replace("#", "");
  const full = raw.length === 3 ? raw.split("").map((c) => c + c).join("") : raw;
  const r = parseInt(full.slice(0, 2), 16) || 0;
  const g = parseInt(full.slice(2, 4), 16) || 101;
  const b = parseInt(full.slice(4, 6), 16) || 248;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const WRITING_CAST_ASSET = (name) => {
  if (name === "pip") return "/assets/pip.png";
  if (name === "benny") return "/assets/benny.png";
  if (name === "zippy-icon") return "/assets/zippy-icon.png";
  return _writingAsset(name);
};
